import { CheckboxGroupResult, RadioGroupResult } from '@myosh/odin-components';

export const labelFormatter = (labelFormat: CheckboxGroupResult[]) => {
  if (!labelFormat || labelFormat.length === 0) {
    return false;
  } else if (labelFormat.length === 2) {
    return 'both';
  } else {
    return labelFormat[0].value as string;
  }
};
export const labelDecimalFormatter = (labelDecimals?: RadioGroupResult | number) => {
  if (!labelDecimals) {
    return undefined;
  }

  if (typeof labelDecimals === 'number') {
    return labelDecimals;
  }

  if (labelDecimals.value === 'one') {
    return 1;
  } else if (labelDecimals.value === 'two') {
    return 2;
  } else {
    return 0;
  }
};
